export default __webpack_public_path__ + "static/media/contingency_admin.72a55d64.jpg";